import styled from 'styled-components';
import { Tooltip, UncontrolledTooltip } from 'reactstrap';

const whiteTooltipStyles = `
  .tooltip {
    opacity: 100%;
  }
  .arrow {
    display: none;
  }
  .tooltip-inner {
    background-color: #ffffff;
    color: var(--text-color);
    text-align: left;
    border: 1px solid var(--border-color);
  }
`;

export const WhiteTooltip = styled(Tooltip)`
  ${whiteTooltipStyles}
  .tooltip-inner {
    max-width: ${({ $maxWidth }) => $maxWidth || '400px'};
  }
`;

export const UncontrolledWhiteTooltip = styled(UncontrolledTooltip)`
  ${whiteTooltipStyles}
  .tooltip-inner {
    max-width: ${({ $maxWidth }) => $maxWidth || '400px'};
  }
`;
